<template>
  <section class="pt-0" :id="'suite-' + this.$router.currentRoute.params.name">
    <HeaderModule :title="$t('title')" :color="color" />
    <div class="container">
      <div class="columns">
        <article class="column">
          <br />
          <p class="is-size-5">{{ $t("intro") }}</p>
          <br />
          <div class="panel-block">
            <table class="table">
              <tbody>
                <tr v-for="(item, index) in $t('main')" :key="index">
                  <td style="white-space: nowrap;">
                    <span class="panel-icon"
                      ><i
                        class="fas fa-circle"
                        :style="'vertical-align: sub;color:' + color"
                      ></i
                    ></span>
                    <b style="margin-right:1rem">{{ item.title }}</b>
                  </td>
                  <td>
                    {{ item.content }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <aside class="column is-4">
          <br />
          <div class=" panel has-background-white-ter">
            <p class="panel-heading">
              <b>{{ $t("aside.request.title") }}</b>
            </p>
            <p
              class="panel-block"
              v-for="(item, index) in $t('aside.request.content')"
              :key="index"
            >
              {{ item }}
            </p>
            <p class="panel-heading">
              <b>{{ $t("aside.characteristics.title") }}</b>
            </p>
            <ul>
              <li
                class="panel-block"
                v-for="(item, index) in $t('aside.characteristics.content')"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </aside>
      </div>

      <div class="card">
        <div class="card-content">
          <h5 class="is-size-4">{{ $t("use.title") }}</h5>
          <hr />
          <div class="columns is-multiline">
            <p
              class="column is-6"
              v-for="(item, index) in $t('use.content')"
              :key="index"
            >
              <span class="panel-icon"
                ><i
                  class="fas fa-check"
                  :style="'vertical-align: sub;color:' + color"
                ></i
              ></span>
              {{ item }}
            </p>
          </div>
        </div>
      </div>
      <br />
      <div class="card">
        <div class="card-content">
          <h5 class="is-size-4">{{ $t("work.title") }}</h5>
          <hr />
          <div class="columns is-multiline">
            <p
              class="column is-6"
              v-for="(item, index) in $t('work.content')"
              :key="index"
            >
              <b class="is-size-6 has-text-grey-darker">{{ item.title }}</b>
              <br />
              {{ item.content }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <FooterModule />
  </section>
</template>
<script>
import FooterModule from "@/components/FooterModules.vue";
import HeaderModule from "@/components/HeaderModules.vue";
export default {
  name: "suite",
  data() {
    return {
      color: "#f05023",
    };
  },
  components: { FooterModule, HeaderModule },
};
</script>
<i18n>
{
    "es": {
        "title": "Monitoreo de Fraude Interno en bancos",
        "intro": "Nuestro sistema flexible de monitoreo de datos basado en reglas y Machine Learning, detecta y previene el fraude bancario interno al alertar a tiempo y generar indicadores de alto riesgo y malas prácticas.",
        "main":[
			{
				"title":"Rentable",
				"content":"Detección precisa de fraude y situaciones sospechosas, reduciendo las pérdidas de la empresa y mejorando eficiencia en análisis."
			},
			{
				"title":"Flexible",
				"content":"Adapta fácilmente al modelo específico del cliente y crea reglas de forma eficiente."
			},
			{
				"title":"Rapidez",
				"content":"Configuración rápida de reglas, alertando sobre casos de fraude en etapas iniciales en tiempo real."
			},
			{
				"title":"Reputación",
				"content":"Se evitan situaciones que podrían generar un impacto reputacional negativo."
			},
			{
				"title":"Auditable",
				"content":"Se guardan logs de auditoría para investigaciones posteriores."
			}
        ],
        "work":{
            "title":"Como Funciona",
            "content":[
				{
					"title":"Editor de Reglas Gráfico",
					"content":"Ceptinel genera reglas de negocio a través del Editor de reglas gráfico del sistema"
				},
				{
					"title":"Alertas y Salidas",
					"content":"Se generan alertas, correos y reportes automáticamente según configuración de la regla. "
				},
				{
					"title":"Conexión e Integración a Múltiples Fuentes de Datos",
					"content":"El sistema Permite cruzar información de múltiples fuentes y niveles de complexidad como bases de datos transaccionales, log de consultas de ejecutivos, personas relacionadas, datos de provedores y empleados, listas negras y blancas externas e internas, etc."
				},
				{
					"title":"Reglas Automatizadas y Customizables",
					"content":"Se aplican tanto reglas propias propuestas por Ceptinel, como reglas específicas del cliente."
				},
				{
					"title":"workflow de gestión de alertas y casos",
					"content":"Se puede convertir cada evento a un caso de gestión, incorporando evidencia, invitando a personas a participar, y cumplir un flujo hasta el cierre del caso.  "
				},
				{
					"title":"Detección Opcional de anomalías con Machine Learning",
					"content":"Se usa un componente de ML para anlizar anomalías en reglas y documentos digitalizados."
				},
				{
					"title":"Log de Auditoría",
					"content":"Se guardan todos los eventos en el log para mostrar evidencia de auditoría interna y externa. "
				}
			]
        },
        "use":{
            "title":"Ejemplos de Casos de Uso",
            "content":[
				"Patrones transaccionales entre empleados y clientes. Por ejemplo transferencias cruzadas.",
				"Modificaciones de datos recurrentes para beneficio del empleado. ",
				"consultas  recurrentes sobre clientes, en particular en horarios poco usuales y sobre cuentas inactivas.",
				"Autorizaciones de producto sin contar con toda la documentación y datos requeridos. ",
				"Ranking/Score de los empleados con mayores puntos de riesgo. "
			]
        },
        "aside":{
            "request":{
                "title":"¿Porque hoy es tan importante?:",
                "content":[
                    "Con un volumen de datos creciendo en forma exponencial, los equipos de fraude y riesgo en los bancos tienen que enfrentarse con el desafío de detectar los casos de fraude y malas prácticas, que son difíciles de hallar mediante métodos y reportes tradicionales o se encuentran cuando es demasiado tarde."
                ]
            },
            "characteristics":{
                "title":"Ventajas Competitivas",
                "content":[
                    "Las soluciones actuales en el mercado son de costo mayor y ofrecen un nivel de flexibilidad más limitado en su workflow, donde cada modificación posterior a las reglas pre-definidas resulta costoso y demoroso"
                ]
            }
        }
    },
    "en": {
        "title": "Internal Banking Fraud Monitoring",
        "intro": "Our flexible data monitoring system based on rules and Machine Learning, detects and prevents internal bank fraud by alerting in time and generating indicators of high risk and bad practices.",
        "main": [
            {
            "title": "Profitable",
            "content": "Precise detection of fraud and suspicious situations, reducing company losses and improving analysis efficiency."
            },
            {
            "title": "Flexible",
            "content": "Easily adapt to the specific model of the client and create rules efficiently."
            },
            {
            "title": "Speed",
            "content": "Quick rule configuration, alerting about early stage fraud cases in real time."
            },
            {
            "title": "Reputation",
            "content": "Situations that could generate a negative reputational impact are avoided."
            },
            {
            "title": "Auditable",
            "content": "Audit logs are kept for later investigations."
            }
        ],
        "work": {
            "title": "How it works",
            "content": [
                {
                "title": "Graphical Rules Editor",
                "content": "Ceptinel generates business rules through the system's graphical rule editor"
                },
                {
                "title": "Alerts and Exits",
                "content": "Alerts, emails and reports are generated automatically according to the configuration of the rule."
                },
                {
                "title": "Connection and Integration to Multiple Data Sources",
                "content": "The system allows to cross information from multiple sources and levels of complexity such as transactional databases, log of inquiries from executives, related persons, supplier and employee data, external and internal black and white lists, etc."
                },
                {
                "title": "Automated and Customizable Rules",
                "content": "Both the own rules proposed by Ceptinel and the customer's specific rules apply."
                },
                {
                "title": "Alerts and cases management workflow",
                "content": "Each event can be converted to a management case, incorporating evidence, inviting people to participate, and following a flow until the closure of the case."
                },
                {
                "title": "Optional Anomaly Detection with Machine Learning",
                "content": "An ML component is used to analyze anomalies in scanned documents and rules."
                },
                {
                "title": "Audit Log",
                "content": "All events are kept in the log to show internal and external audit evidence."
                }
                ]
        },
        "use": {
             "title": "Examples of Use Cases",
             "content": [
              "Transactional patterns between employees and customers. For example, cross transfers.",
              "Recurring data modifications for the benefit of the employee.",
              "Recurring inquiries about clients, particularly at unusual times and about inactive accounts.",
              "Product authorizations without having all the required documentation and data.",
              "Ranking / Score of employees with higher risk points."
              ]
         },
        "aside": {
             "request": {
                 "title": "Why is today so important ?:",
                 "content": [
                     "With a volume of data growing exponentially, fraud and risk teams in banks are faced with the challenge of detecting cases of fraud and malpractices, which are difficult to find using traditional methods and reports or found when It's too late."
                 ]
             },
             "characteristics": {
                 "title": "Competitive Advantages",
                 "content": [
                     "Current solutions on the market are more expensive and offer a more limited level of flexibility in their workflow, where each subsequent modification to the pre-defined rules is costly and time consuming"
                 ]
             }
         }
    },
    "pt": {
        "title": "Monitoramento de fraude bancária interna",
        "intro": "Nosso monitoramento de dados baseado em regras flexíveis e sistema de aprendizado de máquina detecta e evita fraudes bancárias internas, alertando a tempo e gerando indicadores de alto risco e más práticas.",
        "main":[
			{
				"title":"Rentável",
				"content":"Detecção precisa de fraudes e situações suspeitas, reduzindo as perdas da empresa e melhorando a eficiência das análises."
			},
			{
				"title":"Flexível",
				"content":"Adapte-se facilmente ao modelo específico do cliente e crie regras com eficiência."
			},
			{
				"title":"Velocidade",
				"content":"Configuração rápida de regras, alertando sobre casos de fraude em estágio inicial em tempo real."
			},
			{
				"title":"Reputação",
				"content":"Evitam-se situações que possam gerar um impacto negativo na reputação."
			},
			{
				"title":"Auditável",
				"content":"Os logs de auditoria são mantidos para investigações posteriores."
			}
        ],
        "work":{
            "title":"Como funciona",
            "content":[
				{
					"title":"Como funciona",
					"content":"Ceptinel gera regras de negócios por meio do Editor gráfico de regras do sistema"
				},
				{
					"title":"Alertas e saídas",
					"content":"Alertas, emails e relatórios são gerados automaticamente de acordo com a configuração da regra."
				},
				{
					"title":"Conexão e integração a múltiplas fontes de dados",
					"content":"O sistema permite a verificação cruzada de informações de várias fontes e níveis de complexidade, como bancos de dados transacionais, registro de consultas  de executivos, pessoas relacionadas, dados de fornecedores e funcionários, listas internas e negras externas, etc."
				},
				{
					"title":"Regras automatizadas e personalizáveis",
					"content":"Aplicam-se tanto as próprias regras propostas pela Ceptinel, como as específicas do cliente."
				},
				{
					"title":"fluxo de trabalho de gerenciamento de alerta e caso",
					"content":"Cada evento pode ser convertido em um caso de gerenciamento, incorporando evidências, convidando pessoas a participar e seguindo um fluxo até o encerramento do caso."
				},
				{
					"title":"Detecção de anomalias opcional com aprendizado de máquina",
					"content":"Um componente de ML é usado para analisar anomalias em documentos e regras digitalizados."
				},
				{
					"title":"Registro de auditoria",
					"content":"Todos os eventos são registrados para mostrar evidências de auditoria interna e externa."
				}
			]
        },
        "use":{
            "title":"Exemplos de casos de uso",
            "content":[
				"Padrões transacionais entre funcionários e clientes. Por exemplo, transferências cruzadas.",
				"Modificações recorrentes de dados para benefício do funcionário.",
				"Perguntas frequentes sobre clientes, especialmente durante o horário de entrada e sobre contas inativas.",
				"Autorizações de produtos sem ter toda a documentação e dados necessários.",
				"Ranking / Pontuação dos funcionários com maiores pontos de risco."
			]
        },
        "aside":{
            "request":{
                "title":"Por que hoje é tão importante?",
                "content":[
                    "Com um volume de dados crescendo exponencialmente,As equipes de fraude e risco dos bancos enfrentam o desafio de detectar casos de fraude e imperícia, que são difíceis de encontrar por meio de métodos e relatórios tradicionais ou detectados quando já é tarde demais."
                ]
            },
            "characteristics":{
                "title":"Vantagens competitivas",
                "content":[
                    "As soluções atuais no mercado são mais caras e oferecem um nível mais limitado de flexibilidade em seu fluxo de trabalho, onde cada modificação subsequente nas regras predefinidas é cara e demorada."
                ]
            }
        }
    }
}
</i18n>
